<template>
  <div class="signature-pad">
    <p class="text-gray">Signature</p>
    <div @click="signing">
      <VueSignaturePad width="100%" height="150px" ref="signaturePad" />
    </div>
    <p class="text-gray">
      By signing, I agree to the
      <u>
        <a
          class="text-gray"
          href="https://help.fashionphile.com/s/seller-terms-and-conditions"
          target="_blank"
        >Terms & Conditions</a>
      </u>
      of the White Glove service.
    </p>
    <div class="mt-3 actions">
      <button class="btn btn-primary confirmBt" @click="save">{{ saveButtonText }}</button>
      <button
        v-if="!isConfirmed"
        type="button"
        class="btn btn-outline clearBt"
        @click="clearSignature"
      >
        <i class="fa fa-eraser mr-1"></i>
        Clear
      </button>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import VueSignaturePad from 'vue-signature-pad'

Vue.use(VueSignaturePad)
export default {
  name: 'signature-pad',
  data () {
    return {
      saveButtonText: 'Confirm',
      isConfirmed: false
    }
  },
  props: {
    signature: {
      type: String
    }
  },
  methods: {
    signing () {
      this.saveButtonText = 'Save Signature'
    },
    save () {
      if (this.$refs.signaturePad.isEmpty()) {
        this.saveButtonText = 'Please scribble something!'
        return
      }
      this.isConfirmed = true
      this.$refs.signaturePad.lockSignaturePad()
      this.$emit('signatureData', this.$refs.signaturePad.saveSignature().data)
    },
    clearSignature () {
      this.$refs.signaturePad.clearSignature()
      if (this.$refs.signaturePad.unlockSignaturePad) {
        this.$refs.signaturePad.unlockSignaturePad()
      }
      this.saveButtonText = 'Confirm'
      this.$emit('signatureData', '')
    }
  }
}
</script>
<style>
.signature-pad canvas {
  box-shadow: inset 0 0 0.25rem;
  background-color: #eee;
}
.signature-pad .actions {
  display: flex;
  justify-content: space-between; /* first left, second right */
  align-items: center;
  gap: 1rem;
}
.signature-pad button {
  width: 175px;
}
.signature-pad a {
  text-decoration-color:#000000 !important;
}
.signature-pad .text-gray {
  color: #7d7a7a;
}
.signature-pad .confirmBt{
  background-color: #000000 !important;
  color:#fff !important;
}
.signature-pad .clearBt{
  background-color: #ffffff !important; /* white button */
  color:#000000 !important;            /* black text */
  border-color:#000000 !important;     /* black border */
}
</style>
